var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"flex justify-between lg:justify-end md:space-x-8"},[_c('MenuToggle',{staticClass:"space-x-4 item"}),_c('ThemeToggle',{staticClass:"space-x-4 item"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }